<template lang="pug">
    gmh-login(v-if="showForm" :no-redirect="true" redirect-to="profile-page" :settings="settings" :translations="translations")
</template>

<script>
import Cookie from 'js-cookie'

export default {
    name: 'login-page',

    data() { return {
        showForm: false,

        settings: {
            hideRegistration: false,
            hideForgotPassword: false,

            register: {
                route: 'registration-page',
            },
            forgotPassword: {
                route: 'forgot-password-page',
            },

            form: {
                fields: {
                    username: {
                        attr: {
                            lazy: true,
                        },
                    },
                    password: {
                        attr: {
                            lazy: true,
                        },
                    },
                },
            },
        },

        translations: {
            title: 'Let’s get started',
            register: {
                label: 'Don’t have an account?',
                link: 'Register',
            },
            fields: {
                username: {
                    label: 'Email address',
                },
            },
            rememberMe: {
                label: 'Remember me',
            },
            forgotPassword: {
                label: 'Forgot your password?',
            },
            submitButtonTitle: 'Log in',
        },
    }},

    async created() {
        if (this.$route.query.assist) {
            try {
                Cookie.remove('remember_me')

                const { data } = await axios.post('/api/customer/user/assist', {
                    token: this.$route.query.assist,
                })

                this.$store.dispatch('saveToken', {
                    token: data.access_token
                })

                await this.$store.dispatch('fetchUser')

                this.$router.push({ name: 'profile-page' })

                return
            } catch {}
        }

        this.showForm = true
    },
}
</script>
